/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AbstractResourceService, JSONable } from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';

export abstract class SelectableResourceService<T extends JSONable> extends AbstractResourceService<T, T, any, any> {
  private cacheable = false;
  private cacheDuration = 600000;

  protected constructor(
    httpClient: HttpClient,
    url: string,
    vType?: new () => T,
    cacheable = false,
    cacheDuration = 600000
  ) {
    super(httpClient, url, vType, vType);
    this.cacheable = cacheable;
    this.cacheDuration = cacheDuration;
  }

  getType(): new () => any {
    return this.vType;
  }

  getCacheable() {
    return this.cacheable;
  }

  getCacheDuration() {
    return this.cacheDuration;
  }
}
